<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.taxLevels.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyTaxLevelsNew'})"
        >
          Nova stopnja davka
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.taxLevels.length">
      <v-col
        cols="4" md="3" lg="2"
        v-for="item of filteredTaxLevels" :key="item.id"
      >
        <TitleOnlyCard
          :title="`${item.value_formatted}%`"
          @edit="$router.push({name: 'MyCompanyTaxLevelsEdit', params: {id: item.id}})"
          @delete="showDeleteTaxLevelModal = true; deleteTaxLevel = item"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove stopnje davka uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje stopnje davka"
      text="Ali ste prepričani, da želite izbrisati stopnjo davka? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteTaxLevelModal"
      @confirmed="remove(deleteTaxLevel)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteTaxLevelModal: false,
      deleteTaxLevel: null
    }
  },
  computed: {
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    filteredTaxLevels () {
      return this.taxLevels.filter(item => siIncludes({ haystack: `${item.value}`, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('taxLevels', ['loadItems', 'deleteItem']),
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
